import { render } from "./Layout12.vue?vue&type=template&id=21c6368d"
import script from "./Layout12.vue?vue&type=script&lang=js"
export * from "./Layout12.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__